import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ed038bd6&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=ed038bd6&prod&scoped=true&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=ed038bd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed038bd6",
  null
  
)

export default component.exports